import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { Suggestion, SuggestionData } from '../../../components/labels-suggestions/lib/entities';
import { useBookmark } from '../../../context';
import { ResourcePath } from '../../../hooks/resource-path';
import { QueryKey } from '../../../lib/query-key';

export const useGenerateAiSuggestedLabels = () => {
	const http = useHttpClient('v2');
	const { referenceId, referenceType, referenceText, bookmark } = useBookmark();
	return useQuery(
		[QueryKey.SuggestedLabels, referenceId, referenceType],
		async () =>
			http.post<Array<SuggestionData>>(ResourcePath.SuggestedLabels, {
				reference_id: referenceId,
				reference_type: referenceType,
				reference_text: referenceText,
			}),
		{
			staleTime: Infinity,
			refetchOnWindowFocus: false,
			enabled: !!referenceText && !!bookmark && bookmark.labels.length === 0,
			select: (data) => data.data.map((label) => new Suggestion(label)),
		}
	);
};
